import styled, { css } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

import { LIVE_MAP_CHIP_COLOR_MIX_WEIGHTS } from "./live-map.grid-status-breakdown.constants";
import {
  hexColorToRgba,
  mixSrgbHexWithWhite,
} from "./live-map.grid-status-breakdown.utils";

interface ILiveMapPlannedForNowChipButtonStyledProps extends IStyledAttributes {
  $isOn: boolean;
}

export const LiveMapPlannedForNowChipButtonStyled = styled.button.attrs<ILiveMapPlannedForNowChipButtonStyledProps>(
  {
    type: "button",
    [DATA_E2E_KEY]: "live-map-planned-for-now-chip",
  },
)<ILiveMapPlannedForNowChipButtonStyledProps>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-inline-start: 8px;
  padding-block: 2px;
  padding-inline: 7px;
  border: 1px solid ${greyMui._200};
  border-radius: 10px;
  background-color: ${greyMui._50};
  color: ${greyMui._400};
  font: inherit;
  font-size: 11px;
  font-weight: 500;
  appearance: none;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  opacity: 0.88;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    opacity 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    opacity: 1;
    border-color: ${greyMui._300};
    color: ${greyMui._500};
  }

  &:focus-visible {
    outline: 2px solid
      ${hexColorToRgba(
        greyMui._400,
        LIVE_MAP_CHIP_COLOR_MIX_WEIGHTS.focusOutline / 100,
      )};
    outline-offset: 1px;
  }

  ${({ $isOn }) =>
    $isOn &&
    css`
      opacity: 1;
      border-color: ${greyMui._600};
      background-color: ${mixSrgbHexWithWhite(
        greyMui._500,
        LIVE_MAP_CHIP_COLOR_MIX_WEIGHTS.plannedForNowOnBackground,
      )};
      color: ${greyMui._900};
      box-shadow: 0 0 0 1px
        ${hexColorToRgba(
          greyMui._600,
          LIVE_MAP_CHIP_COLOR_MIX_WEIGHTS.plannedForNowOnShadow / 100,
        )};

      .live-map-planned-for-now-chip-icon {
        color: ${greyMui._800};
      }

      .live-map-planned-for-now-chip-count {
        color: ${greyMui._900};
      }
    `}

  .live-map-planned-for-now-chip-icon {
    width: 14px;
    height: 14px;
    color: ${greyMui._400};
    transition: color 0.15s ease;
  }

  .live-map-planned-for-now-chip-label {
    font-weight: 500;
  }

  .live-map-planned-for-now-chip-count {
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    color: ${greyMui._500};
    transition: color 0.15s ease;
  }
`;
